import { Box } from '@chakra-ui/react';
import { TaskHeader } from './containers/TaskHeader';
import { TaskList } from './containers/TaskList';
import { TaskRegistrationModal } from './containers/TaskRegistrationModal';
import { TaskEditModal } from './containers/TaskEditModal';
import { TaskDeleteModal } from './containers/TaskDeleteModal';

export const ReleaseTaskPageView = () => (
  <Box m="40px">
    {/* ヘッダ */}
    <TaskHeader />
    {/* タスク一覧 */}
    <TaskList />
    {/* タスク登録モーダル */}
    <TaskRegistrationModal />
    {/* タスク登録モーダル */}
    <TaskEditModal />
    {/* タスク削除モーダル */}
    <TaskDeleteModal />
  </Box>
);
